/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 * 
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

/** A simple smoothing class. */
export default class SmoothedNumber {

    /** Current value */
    value = 0

    /** Amount still to be added */
    incoming = 0

    /** Value change speed multiplier */
    speed = 10

    /** 
     * Constructor 
     * 
     * @param {object} opts Optional config
     * @param {number} opts.value Initial value. Default = 0.
     * @param {number} opts.speed Speed multiplier. Default = 10.
     */
    constructor(opts) {
        this.value = opts?.value || 0
        this.speed = opts?.speed || 10
    }

    /**
     * Set the value and apply smoothing.
     * @param {number} v New value.
     */
    set(v) {

        // Add to incoming
        this.incoming = (v || 0) - this.value

    }

    /**
     * Set the value without applying smoothing.
     * @param {number} v New value.
     */
    setImmediate(v) {

        // Set directly
        this.incoming = 0
        this.value = v

    }

    /** Increase by a specified amount */
    increase(v) {
        this.incoming += v || 0
    }

    /** Update each frame */
    update(delta) {

        // Check if done
        if (this.incoming == 0)
            return

        // Check if close enough to stop
        if (Math.abs(this.incoming) < 0.0001) {
            this.value += this.incoming
            this.incoming = 0
            return
        }

        // Get a small portion to increase by
        let portion = this.incoming * this.speed * delta
        if (Math.abs(portion) > Math.abs(this.incoming)) portion = this.incoming
        this.incoming -= portion
        this.value += portion

    }

    /** Claim value. This will return the number, and then reset to 0. If you just want the number, use the `.value` property. */
    claim() {
        let v = this.value
        this.value = 0
        this.lastClaimedValue = v
        return v
    }

}